export const CATEGORY_ADMIN_ACTION = {
    GET_CATEGORY_LIST: "CATEGORY_ADMIN_ACTION/GET_CATEGORY_LIST",
    CREATE_CATEGORY: "CATEGORY_ADMIN_ACTION/CREATE_CATEGORY",
};
